module.exports = __webpack_public_path__ + "img/icon-user.5b7b44ae.svg";